import getDecryptedData from "@/utils/decrypt";

export default {
    getUserData(){
        const encrypted = localStorage.getItem('userData'); 
        
        if(!encrypted || encrypted === 'undefined') return null;  
        
        return getDecryptedData(encrypted, "@qG56W5w04YI");
    }
}